import "../catalog/styles/Catalog.css"
import catalogColumns from "../catalog/columns/catalogColumns"
import React, { FC, useEffect, useState } from "react"
import { RootState } from "../../../store"
import { connect } from "react-redux"
import { Release, TakedownOverviewProps } from "../../../types"
import { fetchCatalogData } from "../../../actions/catalogActions"
import CatalogTable from "../catalog/CatalogTable"
import { lang } from "../../../constants/languages"
import { KSpan, KTitleSpan } from "kahuna-base-react-components"
import { users } from "../../../apis"
import { getCurrency } from "../../../utility"

const TakedownOverview: FC<TakedownOverviewProps> = (props) => {
  const { selectedCatalogFilter } = props
  const [loading, setLoading] = useState(true)
  const [tableData, setTableData] = useState<Release[]>([])
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [currency, setCurrency] = useState("")
  const [advanceTotal, setAdvanceTotal] = useState(0)

  const limit = 10

  const fetchSync = async (pageNumber: number) => {
    await props.fetchCatalogData(
      limit,
      (pageNumber - 1) * limit,
      props.user.id!,
      selectedCatalogFilter,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      true
    )
  }

  useEffect(() => {
    fetchSync(pageNumber).then(() => setLoading(false))
  }, [selectedCatalogFilter])

  useEffect(() => {
    setTableData(props.paginatedReleases.results)
  }, [props.paginatedReleases])

  const fetchUserAdvanceList = () => {
    users(`/current_user_advance/`, "GET").then((resp) => {
      if (!resp.data.result) {
        return
      }
      setAdvanceTotal(resp.data.result.advance_total)
      setCurrency(resp.data.result.preferred_currency)
    })
  }

  useEffect(() => {
    localStorage.removeItem("takedownOverview")

    fetchUserAdvanceList()
  }, [])

  const onClickPage = async (pageNumber: number) => {
    setLoading(true)
    fetchSync(pageNumber).then(() => {
      setLoading(false)
    })
    setPageNumber(pageNumber)
  }

  return (
    <div>
      {advanceTotal > 0 && (
        <div className="mb-8 flex">
          <div
            className="min-w-[260px] rounded-2xl px-6 py-5"
            style={{
              background: "linear-gradient(135deg, rgb(156 156 156) 0%, rgb(43, 43, 43) 100%)",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}
          >
            <KSpan fontSize={14} text={lang.catalog.advance_payment} color="rgba(255,255,255,0.7)" />

            <div className="flex items-end gap-2 mt-5">
              <KSpan
                text={`${getCurrency(currency)}${advanceTotal.toLocaleString("en-EN", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })}`}
                fontSize={42}
                color="#fff"
                fontWeight={600}
              />
            </div>

            <div
              className="mt-5 pt-4"
              style={{
                borderTop: "1px solid rgba(255,255,255,0.08)"
              }}
            >
              <KSpan text={lang.catalog.advance_payment_description} fontSize={13} color="rgba(255,255,255,0.55)" />
            </div>
          </div>
        </div>
      )}

      <div className="catalog flex-grow mt-6">
        <CatalogTable
          title={lang.catalog.title}
          pagination
          minRowCount={limit}
          limit={limit}
          columns={catalogColumns}
          data={tableData}
          count={props.paginatedReleases.count}
          onClickPage={onClickPage}
          rowHeightInPx={40}
          loading={loading}
          viewOnly={true}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user,
    paginatedReleases: state.catalogData.paginatedReleases,
    selectedCatalogFilter: state.catalogData.selectedCatalogFilter
  }
}

export default connect(mapStateToProps, { fetchCatalogData })(TakedownOverview)
